import type { ProductMM } from '~/entities';

import { mapProductCompilationsToProductMM } from '../mappers/mapProductCompilationsToProductMM';
import { productService } from '#shared/api/ke-gateway/product';

const PAGE = 0;
const SIZE = 25;

export async function getPopularProducts(): Promise<ProductMM[]> {
  try {
    const response = await productService.getProductCompilations(PAGE, SIZE);
    if (!response) return [];

    const mappedResponse = mapProductCompilationsToProductMM(response);

    return mappedResponse[0]?.productList ?? [];
  } catch (e) {
    return [];
  }
}
